import './FeedBackButton.css';
import React, { useState } from 'react';
import { FaThumbsUp } from 'react-icons/fa';
import FeedBackForm from '../../panels/Forms/FeedBackForm';
import { NavigateFunction } from 'react-router-dom';

interface Props {
  parentPageUrl: string;
  token: string | null;
  nav: NavigateFunction;
}

function FeedBackButton({ parentPageUrl, token, nav }: Props): JSX.Element {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  return (
    <div>
      <button className="FeedBackButton" onClick={handleFormToggle}>
        <FaThumbsUp />
      </button>
      {isFormOpen && (
        <FeedBackForm
          parentPageUrl={parentPageUrl}
          token={token}
          nav={nav}
          handleCloseFormPressed={handleFormToggle}
        />
      )}
    </div>
  );
}

export default FeedBackButton;
